import React, { FC, useState } from "react";
import {
    Grid,
    Typography,
} from "@mui/material";
import SinglePaymentCard from "./SinglePaymentCard";

type PaymentCard = {
    id: string;
    brand: string;
    last4: string;
    customer: string;
    exp_month: number;
    type: string;
    exp_year: number;
};

type PaymentMethodsProps = {
    cards: PaymentCard[];
    defaultSource: string
};

const PaymentMethods: FC<PaymentMethodsProps> = ({ cards, defaultSource }) => {
    return (
        <div>
            <Grid container spacing={2}>
                {cards && cards?.length > 0 ? (
                    cards?.filter(item => item.type === 'card').map((card) => (
                        <SinglePaymentCard card={card} defaultSource={defaultSource} />
                    ))
                ) : (
                    <Typography variant="body1" color="textSecondary">
                        No payment methods available.
                    </Typography>
                )}
            </Grid>
        </div>

    );
};

export default PaymentMethods;
